import React from "react";
import { useNavigate } from "react-router-dom";
import "./Hero.css";

function Hero() {
  const navigate = useNavigate();

  return (
    <section className="hero">
      <div className="hero-content">
        <h1>CRÉATIONS UNIQUES EN BOIS FAIT MAIN</h1>
        <div className="divider-line"></div>
        <p className="subtitle">Objets de décoration faits à la scie à chantourner</p>
        <div className="divider-line"></div>
        <button className="btn-discover" onClick={() => navigate('/boutique')}>
          DÉCOUVRIR LA BOUTIQUE
        </button>
      </div>
    </section>
  );
}

export default Hero;
